import React, { useRef, useState } from "react";
import "./QuestionsPreview.css";

import plusIcon from "./assets/svg/plus.svg";
import minusIcon from "./assets/svg/minus.svg";
import qnaIcon from "./assets/svg/qna.svg";

const QuestionsPreview = ({ questions = [], onSeeAll }) => {
  return (
    <section className="questions-preview">
      
      {/* BACKGROUND SHAPES */}
      <div className="bg-container">
        <div className="bg-1"></div>
        <div className="bg-2"></div>
      </div>

      {/* CONTENT ON TOP */}
      <div className="questions-content">
        <h2 className="questions-title">
          <img src={qnaIcon} alt="" className="qna-icon" />
          Kérdések és válaszok
        </h2>

        {/* SCROLLABLE FAQ AREA */}
        <div className="questions-scroll">
          {questions.map((q, i) => (
            <QuestionRow key={i} question={q} />
          ))}
        </div>

        <button className="faq-seeall" onClick={onSeeAll}>
          See full FAQ
        </button>
      </div>

    </section>
  );
};

function QuestionRow({ question }) {
  const [open, setOpen] = useState(false);
  const contentRef = useRef(null);

  return (
    <div className="question-row">
      <button className="question-header" onClick={() => setOpen(!open)}>
        <span>{question.title}</span>
        <img
          src={open ? minusIcon : plusIcon}
          className="q-icon"
          alt="toggle"
        />
      </button>

      <div
        className="question-body-wrapper"
        style={{ height: open ? contentRef.current?.scrollHeight : 0 }}
      >
        <div className="question-body" ref={contentRef}>
          {question.answer}
        </div>
      </div>
    </div>
  );
}

export default QuestionsPreview;
